import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';

/** Record client-side route changes. The first view is already sent by the page tags. */
export default function RouteAnalytics() {
  const location = useLocation();
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }

    const pagePath = `${location.pathname}${location.search}`;
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: pagePath,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
    if (typeof window.analytics?.page === 'function') {
      window.analytics.page();
    }
    if (posthog.__loaded) {
      posthog.capture('$pageview', { $current_url: window.location.href });
    }
  }, [location.pathname, location.search]);

  return null;
}
